import type { ReceiptTemplate } from '../schema';

export const americanAirlinesTemplate: ReceiptTemplate = {
  id: 'american-airlines',
  name: 'American Airlines Receipt',
  brand: 'AMERICAN AIRLINES',
  description: 'American Airlines flight receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'aa-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'AMERICAN AIRLINES',
        businessNameFontSize: 14,
        addressLines: ['E-TICKET RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'aa-booking',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'confirm', label: 'Confirm #:', value: 'ABCD12' },
          { id: 'passenger', label: 'Passenger:', value: 'JOHN DOE' },
        ],
        column2: [
          { id: 'ticket', label: 'Ticket #:', value: '0018472910' },
          { id: 'date', label: 'Issue Date:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'aa-flight',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'FLIGHT: AA 1234\nFROM: LAX - Los Angeles\nTO: JFK - New York\nDATE: 01/15/2026\nDEPART: 8:00 AM\nARRIVE: 4:30 PM', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'aa-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'fare', label: 'BASE FARE', value: '289.00', isBold: false, isLarge: false },
          { id: 'taxes', label: 'TAXES & FEES', value: '42.50', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '331.50', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'aa-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'aa-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'AADVANTAGE MEMBER\n\nTHANK YOU FOR FLYING', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

